export default "__VITE_ASSET__BoIs73SX__"